console.log("start change buynow")
document.addEventListener("DOMContentLoaded", function() {
  var currentPageUrl = window.location.pathname; // Get the current page path

  
if (currentPageUrl.includes('/zh/products') || currentPageUrl.includes('/zh/collections')) {
  
    
    var buyNowButtons = document.querySelectorAll('a.btn');
    console.log("Number of buttons found: " + buyNowButtons.length);
    
    buyNowButtons.forEach(function(button) {
      console.log("Button text: " + button.textContent.trim());
      if (button.textContent.trim() === "Buy Now") {

        button.textContent = '立即購買';
      }
      if (button.textContent.trim() === "Enquiry Now") {

        button.textContent = '按此詢問';
      }
    });
  }

});


